import React, { useEffect, useState } from 'react';
import firebase from '../../FirebaseConfig/firebase';
import './test.scss';

const Test = () => {

    const db = firebase.firestore();

    //Get documents from firestore
    const [schools, setSchools] = useState([]);
    useEffect(() => {
        db.collection('users').where('displayName', '==', 'sanjana sithira').get().then((snapshot) => {
            const s = snapshot.docs.map((doc => {
                return {
                    id: doc.id,
                    ...doc.data()
                };
            }));

            setSchools(s);
            console.log(s);
        });

    }, []);


    //Add an image to firestore
    const [fileUrl, setFileUrl] = useState('');
    const [userName, setUserName] = useState('');

    const onFileChange = async (e) => {
        const file = e.target.files[0];
        const storageRef = firebase.storage().ref();
        const fileRef = storageRef.child('carousel/' + file.name);
        await fileRef.put(file);
        setFileUrl(await fileRef.getDownloadURL());
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const name = userName;
        if (!name) {
            return;
        }

        db.collection('projects').add({
            name: userName,
            imageURL: fileUrl
        });
    };


    return (
        <div className="test-container">

            <input type="file" onChange={onFileChange} />
            <input type="text" onChange={(e) => {
                setUserName(e.target.value);
            }} />
            <button onClick={handleSubmit} >Submit</button>
        </div>
    );
};

export default Test;
